import React from "react";
import { Descriptions } from "antd";
import {
  getLabelTag,
  getLabelTagInput,
} from "../../../IpEMR/InspectionSummaries/constructTextFromValues";
import {
  ambulanceAssistanceOptions,
  ambulanceBedBoundOptions,
  ambulanceOptions,
  bladderIncontinenceOptions,
  bowelIncontinenceOptions,
} from "../../../IpEMR/Options/funcExamOptions";

const FunctionalStatus = ({ details }) => {
  const constructFunctionalExaminationSummaryItems = () => {
    const functionalExaminationSummaryItems = [];

    if (details?.ambulation) {
      functionalExaminationSummaryItems.push({
        key: "1",
        label: "Ambulation",
        children: (
          <>
            {getLabelTag(ambulanceOptions, details?.ambulation)}
            {getLabelTag(
              ambulanceAssistanceOptions,
              details?.ambulation_assistance
            )}
            {getLabelTagInput(
              "Others details",
              details?.ambulation_assistance_others
            )}
            {getLabelTag(
              ambulanceBedBoundOptions,
              details?.ambulation_bed_bound
            )}
          </>
        ),
      });
    }
    if (details?.bowel_incontinence) {
      functionalExaminationSummaryItems.push({
        key: "2",
        label: "Bowel Incontinence",
        children: getLabelTag(
          bowelIncontinenceOptions,
          details?.bowel_incontinence
        ),
      });
    }
    if (details?.bladder_incontinence) {
      functionalExaminationSummaryItems.push({
        key: "3",
        label: "Bladder Incontinence",
        children: getLabelTag(
          bladderIncontinenceOptions,
          details?.bladder_incontinence
        ),
      });
    }
    return functionalExaminationSummaryItems;
  };
  return (
    <>
      <Descriptions
        bordered={false}
        column={1}
        items={constructFunctionalExaminationSummaryItems()}
        style={{ textAlign: "left", marginTop: "10px" }}
        className="review-desc"
      />
    </>
  );
};

export default FunctionalStatus;
